export class ShapeError extends Error {
    shape;
    constructor(shape, message) {
        super(message);
        this.shape = shape;
    }
}
export class ShapeAssertError extends ShapeError {
    value;
    name = "ShapeAssertError";
    constructor(shape, value, message) {
        super(shape, message);
        this.value = value;
    }
}
export class ShapeEncodeError extends ShapeError {
    value;
    name = "ShapeEncodeError";
    constructor(shape, value, message) {
        super(shape, message);
        this.value = value;
    }
}
export class ShapeDecodeError extends ShapeError {
    buffer;
    name = "ShapeDecodeError";
    constructor(shape, buffer, message) {
        super(shape, message);
        this.buffer = buffer;
    }
}
//# sourceMappingURL=util.js.map